import React, { useState } from "react";
import { Formik, Form as FORM } from "formik";
import { Link, useHistory } from "react-router-dom";
import * as Yup from "yup";
// import Button from "../Utility/Button";
import { useSelector } from "react-redux";
// import "./Professional.css";
import { notifyerror, notifysuccess } from "../Utility/Notification";
import { Helmet } from "react-helmet";
import {domain} from "../App";
import FormControl from '@material-ui/core/FormControl';
import {styled} from '@material-ui/core/styles'
import Hidden from "@material-ui/core/Hidden";
import Typography from "@material-ui/core/Typography";
import TextField from "@material-ui/core/TextField";
import Button from '@material-ui/core/Button'
import CircularProgress from "@material-ui/core/CircularProgress";
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import {database} from '../firebase';


const Wrapper=styled('div')({
  width:'100%',
  minHeight:'100vh',
  maxHeight:'100vh',
  display:'flex',
  alignItems:'center',
  justifyContent:'center',
  flexDirection:'row'
})

const LeftLogo=styled('div')({
  width:'50%',
  height:'100vh',
  backgroundColor:'#f0f0f0',
  display:'flex',
  alignItems:'center',
  justifyContent:'center',
  flexDirection:'column'
})

const FormContainer=styled('div')({
  width:'100%',
  height:'100vh',
  display:'flex',
  alignItems:'center',
  justifyContent:'center',
  flexDirection:'column'
})

const SelectContainer = styled(Select)({
  width:'100%',
  marginTop:'10px'

})
const FormSetter=styled('div')({
  paddingTop:'40px',
  width:'90%',
  maxWidth:'400px',
  display:'flex',
  alignItems:'center',
  justifyContent:'center',
  flexDirection:'column'
  // backgroundColor:'#46516d'
})

const StyledLogo=styled('div')({
  width:'250px',
  height:'200px'
})

const StyledText=styled(Typography)({
  textAlign:"center",
  paddingTop:"30px"
})

const StyledField=styled(TextField)({
  marginTop:'10px'
})

const StyledButton=styled(Button)({
  marginTop:'10px',
  backgroundColor:'#46516d',
  color:'#fff',
  width:'90%',
  border:'1px solid #46516d',
  maxWidth:'400px',
  '&:hover':{
    backgroundColor:'#46516d',
  }
})

const initialvalue = {
  work: "",
  address: "",
  description: "",
};

const validation = Yup.object({
  work: Yup.string()
      .min(2, "please enter correct work")
      .max(10, "please enter correct work")
      .required("Required"),
  description: Yup.string()
      .min(3, "description should be min 3 characters")

      .required("Required"),
  address: Yup.string()
      .min(3, "Landmark should be min 3 characters")
      .required("Required"),
});

const Requestform = ({category}) =>{

  const cat=[
    {
      title:'TV repairing',
      key:'tv'
    },
    {
      title:'washing-machine',
      key:'Washing-machine'
    },{
      title:'Microwave repairing',
      key:'microwave'
    },
    {
      title:'Ac Repairing',
      key:'ac'
    },
    {
      title:'Fridge Repairing',
      key:'fridge'
    },
    {
      title:'ro/filter',
      key:'Ro/filter'
    },
{
  title:"internal home wiring",
  key:"internal wiring for home"
},
{
  title:"other electrical equipment",
  key:"electrical equipment"
}
  ];
  const [loading,setLoading]=useState(false)
  const handleSubmit = async(values) =>{
    // e.preventDefault();
    // console.log(values,"--values")
   setLoading(true);
    database.collection("user").doc().set({
      work: values.work,
      description: values.description,
      address: values.address,

    }).then(()=>{
      console.log("Document successfully written!");
    }).catch((error)=>{
      console.log(error);
    }).finally(()=>{
      setLoading(false);
      notifysuccess("Request Registered Successfully")
    });
  }


  return(
      <>
        <Helmet>
          <title>Service Request</title>
          <meta
              name="description"
              content="Fill below form and we will make sure that your appliance is running smooth and dosen't need second service"
          />
        </Helmet>
        <Wrapper>
          <FormContainer>
            <StyledText variant='h4'>
              Register your complaint
            </StyledText>
            <FormSetter>
              <Formik
                  initialValues={initialvalue}
                  validationSchema={validation}
                  onSubmit={handleSubmit}
              >
                {props=>{
                  const{
                    values,
                    touched,
                    errors,
                    handleChange,
                    handleBlur,
                  }=props;
                  return(
                      <FORM autoComplete='true' style={{width:'100%'}}>
                        <StyledField
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.description}
                            variant='outlined'
                            fullWidth
                            margin='dense'
                            type="text"
                            label='Description.'
                            name='description'
                            error={errors.description&&touched.description?true:false}
                            helperText={errors.description && touched.description?errors.description:null}
                        />
                        <FormControl variant="outlined" style={{width:'100%'}}>
                          <InputLabel htmlFor="work">Work</InputLabel>
                          <SelectContainer
                              native
                              // value={state.age}
                              onChange={handleChange}
                              label="Work"
value={category?category:values.work}
                              inputProps={{
                                name: 'work',
                                id: 'Work',
                              }}
                              name='work'
                              error={errors.work&&touched.work?true:false}
                              helperText={errors.work&&touched.work ?errors.work:null}
                          >
                            {
                              cat.map((data,index)=>{
                                return (
                                    <option key={index} value={data.key}>{data.title}</option>)
                              })
                            }


                          </SelectContainer>
                        </FormControl>
                        <StyledField
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.address}
                            variant='outlined'
                            fullWidth
                            margin='dense'
                            type='text'
                            label='Address'
                            name='address'
                            error={errors.address&&touched.address?true:false}
                            helperText={errors.address&&touched.address ?errors.address:null}
                        />
                        <div style={{width:'100%',display:'flex',alignItems: 'center',justifyContent: 'center'}}>
                          <StyledButton
                              disableFocusRipple={true}
                              disableElevation={true}
                              type='submit'
                              // onClick={handleSubmit}
                              variant='outlined'
                              disabled={loading?true:false}
                          >
                            {loading ?
                                <CircularProgress style={{height:'20px',width:'20px',color:'#fff'}} />
                                : 'Register complaint'}
                          </StyledButton>
                        </div>
                      </FORM>
                  )
                }}
              </Formik>
            </FormSetter>
            <Typography>Or</Typography>
            <StyledButton
                disableFocusRipple={true}
                disableElevation={true}
                type='submit'
                variant='outlined'

                disabled={loading ? true : false}
            >
              <a style={{color:'white',textDecoration:'none'}} href={"tel:+919644917257"}>Call Us</a>
            </StyledButton>
          </FormContainer>

        </Wrapper>
      </>
  );
}

export default Requestform;
